import { selector } from 'recoil';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { checkoutProgressAtom } from '../atoms/checkoutProgressAtom';
import { getCheckoutConfig } from '../../pages/CheckoutPage/configs/CheckoutAccordionConfig';
import { accountHolderAtom } from '../atoms/accountHolderAtom';
import { externalCasesAtom } from '../atoms/externalCasesAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { notUpdatedCoverablesAtom } from '../atoms/notUpdatedCoverablesAtom';
import { containsAddCoverageChangeSelector } from './containsAddCoverageSelector';
import { isOpcJobSelector } from './isOpcJobSelector';
import type { CheckoutStepInfo } from '../types/onsaTypes';

export const checkoutProgressSelector = selector<CheckoutStepInfo>({
    key: 'checkoutProgressSelector',
    get: ({ get }) => {
        const currentStep = get(checkoutProgressAtom);
        const notUpdatedCoverables = get(notUpdatedCoverablesAtom);
        const coverables = get(allCoverablesAtom);
        const externalCasesData = get(externalCasesAtom);
        const { isPolicyChange } = get(jobInfoAtom);
        const containsAddCoverageChange = get(containsAddCoverageChangeSelector);
        const { isCVR } = get(accountHolderAtom);
        const isOpcJob = get(isOpcJobSelector);
        const checkoutAccordions = getCheckoutConfig(
            coverables,
            externalCasesData,
            isPolicyChange ?? false,
            isOpcJob,
            isCVR,
            containsAddCoverageChange,
            notUpdatedCoverables
        ).filter((accordion) => !accordion.disabled);

        return {
            steps: checkoutAccordions,
            currentStep,
            currentStepName:
                checkoutAccordions.length > 0 ? checkoutAccordions[currentStep - 1].stepId : '',
            totalSteps: checkoutAccordions.length
        };
    }
});
